import React from 'react';
import Header from './Header'
import Menu from './Menu'

class NavBar extends React.Component {

    render() {
        return (
            <header id="site_header" className="header mobile-menu-hide">
                <Header siteTitle={this.props.siteTitle} siteDescription={this.props.siteDescription} />
                <Menu />
            </header>
        );
    }

}

export default NavBar;
